import React from 'react';
import {TabletOutlined, Print, CreditCardOutlined} from '@material-ui/icons';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import styled from 'styled-components';

const IconStyle = styled.div`
  & > svg {
    font-size: 16px;
  }
`;

const StyledIpadMiniIcon = styled(IconStyle)`
  & > svg {
    font-size: 12px;
  }
`;

interface DeviceIconProps {
  deviceType: DeviceType;
}

export default function DeviceIcon({deviceType}: DeviceIconProps) {
  switch (deviceType) {
    case DeviceType.IPAD:
      return (
        <IconStyle>
          <TabletOutlined />
        </IconStyle>
      );
    case DeviceType.IPAD_MINI:
      return (
        <StyledIpadMiniIcon>
          <TabletOutlined />
        </StyledIpadMiniIcon>
      );
    case DeviceType.RECEIPT_PRINTER:
      return (
        <IconStyle>
          <Print />
        </IconStyle>
      );
    case DeviceType.PAYMENT_TERMINAL:
      return (
        <IconStyle>
          <CreditCardOutlined />
        </IconStyle>
      );
    default:
      return (
        <IconStyle>
          <TabletOutlined />
        </IconStyle>
      );
  }
}
